/** React Query hook for fetching signal subtypes. */

import { useQuery } from '@tanstack/react-query';
import { tradingApi } from '../services/tradingApi';
import type { SignalSubtypeResponse } from '../types/strategy';

export function useSignalSubtypes() {
  return useQuery<SignalSubtypeResponse[]>({
    queryKey: ['signal-subtypes'],
    queryFn: () => tradingApi.getSignalSubtypes(),
    staleTime: 5 * 60 * 1000,
  });
}
